<template>
  <div>
    <div v-for="(domain, index) in updatedDomains" :key="`${domain}-${index}`">
      <div class="form-group">

        <form-input input-classes="form-inline"
                    element-classes=""
                    :error="errors[index]"
                    :value="domain"
                    @form-input="updateDomain(index, $event)">
            <span slot="after-input">
              <label class="sr-only" :for="`trash-domain-${index}`">Trash</label>
              <a :id="`trash-domain-${index}`"
                 href="#" role="button" class="ml-2"
                 @click="removeDomain(index)">
                <icon class="btn-icon text-danger" name="trash" scale="1.0"/>
              </a>
            </span>
        </form-input>

      </div>
    </div>

    <div class="form-inline">
      <button class="btn btn-primary mb-4"
              :disabled="isMaxDomains"
              type="button"
              @click="addDomain">
        <icon class="btn-icon" name="plus-circle"></icon>
        Add Domain
      </button>
    </div>

  </div>
</template>

<script>
  import FormInput from '@/components/administration/common/form/FormInput'
  import clone from 'ramda/src/clone'
  import 'vue-awesome/icons/trash'
  import 'vue-awesome/icons/plus-circle'
  import eventBus from '@/services/event-bus/event-bus'

  export default {
    props: {
      domains: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      errors: {
        type: Object,
        default: () => ({})
      }
    },

    components: {
      'form-input': FormInput
    },

    data() {
      return {
        updatedDomains: clone(this.domains)
      }
    },

    watch: {
      updatedDomains() {
        this.$emit('domains-updated', this.updatedDomains)
        eventBus.$emit(this.$enums.events.settingsClearErrors, 'domains_whitelist')
      }
    },

    computed: {
      isMaxDomains() {
        return this.updatedDomains.length > 50
      }
    },

    methods: {
      addDomain() {
        this.updatedDomains.push('')
      },

      removeDomain(index) {
        this.updatedDomains.splice(index, 1)
      },

      updateDomain(index, value) {
        this.updatedDomains.splice(index, 1, value)
      }
    }
  }
</script>
